export default {
  banner: {
    title: "About us",
    subtitle:
      "Authing Make identity management easy and protect enterprise data assets",
    "label-one": "User authentication",
    "label-two": "Distribution countries",
    "label-three": "Customer service",
    "label-four": "Service time",
  },
  company: {
    title: "Company introduction",
    "descript-one": `Authing is the first developer-centric identity cloud in China. It integrates all the mainstream identity authentication protocols and provides complete and secure user authentication and access management services for enterprises and developers. Authing was recognized as "2020 national high tech enterprise" by the Ministry of science and technology, and was selected as "domestic innovation enterprise in the field of identity management and access control" by the China Academy of information and communications, and was included in the 2019 white paper on the network security industry. In August 2021, Authing was selected as one of Forbes Asia's Top 100 Companies to Watch list. In September 2021, Authing was successfully selected as a member unit of the "Zhuoxin Big Data Project" of the China Academy of Information and Communications Technology. Authing is now having 200+ employees & has created an excellent development model, efficient office procedure, and safety management system for enterprises across the world, such as PetroChina, State Grid, China Merchants Bank, Toyota, JCDecaux group, etc.`,
    "descript-two":
      "Authing key features include Single Sign-On, User Analytics, Swipe Sign-On, Adaptive MFA, Behavioral Auditing, Risk Management, Cross-platform Device Management, IoT Authentication, etc.; compatible with various international standard protocols: OAuth2.0, OIDC, SAML, AD/ LDAP, WS-Fed, JWT, etc.; there is also Pipeline for function-based computing that extends Authing capabilities without limit. Authing supports cloud delivery and private deployment methods to help enterprises and developers enhance productivity a thousandfold.",
  },
  process: {
    title: "Development process",
    imgUrl: "//files.authing.co/authing-website/about-company-process-en.png",
  },
  copyright: {
    title: "Software copyright",
  },
  form: {
    title: "Want to learn more about pricing for the Enterprise Edition?",
    subtitle:
      "Please fill in your contact information and one of our technical experts will be in touch with you shortly to help you solve your problem.",
  },
  link: {
    title: "Related links",
    website: "Website",
    doc: "Doc",
    devCommunity: "Community",
    joinus: "Join Us",
  },
};
